import { render, staticRenderFns } from "./CreateTransaction.vue?vue&type=template&id=d0b60796&scoped=true&"
import script from "./CreateTransaction.vue?vue&type=script&lang=js&"
export * from "./CreateTransaction.vue?vue&type=script&lang=js&"
import style0 from "./CreateTransaction.vue?vue&type=style&index=0&id=d0b60796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b60796",
  null
  
)

export default component.exports